import React from 'react'
import {PizzaWrapper, PizzaHeader, PizzaCard, Row1, RowLight, RowBold} from "./PizzaStyle"

function Pizza() {
    return (
        <PizzaWrapper>
            <PizzaHeader>You Like What I Do? BUY ME A PIZZA</PizzaHeader>
            {/* <PizzaHeader>You Like What I Do?<p>BUY ME A PIZZA</p></PizzaHeader> */}
            <PizzaCard>
                <Row1>
                    <RowLight>bank:</RowLight>
                    <RowBold>fidelity</RowBold>
                </Row1>
                <Row1>
                    <RowLight>account name:</RowLight>
                    <RowBold>ubani u. friday</RowBold>
                </Row1>
                <Row1>
                    <RowLight>account no:</RowLight>
                    <RowBold>6321946309</RowBold>
                </Row1>
            </PizzaCard>
        </PizzaWrapper>
    )
}

export default Pizza
